import { Component, OnInit } from '@angular/core';
import { ContactService } from '../rest_services/contact.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  contactLoading:boolean=true;
  allContact: any[] = [];
  

  constructor(private contactService : ContactService) { }

  ngOnInit(): void {
    this.getAllContacts();
  }

  getAllContacts() {
    this.contactService.getAllContacts();
    this.contactService.contactsSubject.subscribe((response: any) => {
      this.contactLoading = false;
      if(response.code=="f898fba515734ae7b269f99e100c061e"){
        this.allContact = response.contacts;
        setTimeout(()=>{
          (<any>$("#alter_pagination")).DataTable( {
            "destroy":true,
            "pagingType": "full_numbers",
            "scrollX": '400px',
            "scrollCollapse": true,
            "aaSorting": [],
            "iDisplayLength": 25,
            // columnDefs: [ { type: 'date', 'targets': [2], "orderable": true } ],
            "language": {
              "sProcessing": "Traitement en cours ...",
              "sLengthMenu": "Afficher _MENU_ lignes",
              "sZeroRecords": "Aucun résultat trouvé",
              "sEmptyTable": "Aucune donnée disponible",
              "sInfo": "",
              "sInfoEmpty": "",
              searchPlaceholder: "Saisir un mot clé",
              "sInfoFiltered": "",
              "sInfoPostFix": "",
              "sSearch": "Rechercher:",
              "sUrl": "",
              "sInfoThousands": ",",
              "sLoadingRecords": "Chargement...",
              "oPaginate": {
                "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
              },
              "oAria": {
                "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
              }
            },
            drawCallback: function () {
              (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                    type: 'line',
                    width: '60',
                    height: '20',
                    lineColor: '#1a73e9',
                    fillColor: '#c2d5ff',
                    spotColor: 'transparent',
                    minSpotColor: 'transparent',
                    maxSpotColor: 'transparent',
                    highlightSpotColor: 'transparent',
                    highlightLineColor: 'transparent',
                });
            }
        });
      }, 200);
      }else{
        this.allContact=[];
      }
    },
    (err: any) => {
      console.log(err);
      
    }
      );
  }
  
  sendMessageWhatsapp(phone:any){
    var phoneMember = phone.replace(/\s/g, "");
    phoneMember = phoneMember.replace(/-/g, "");
    var newString = phoneMember.indexOf( '0' ) == 0 ? phoneMember = phoneMember.replace( '0', '+212' ) : phoneMember;
    window.open('https://api.whatsapp.com/send/?phone='+newString+'&text&app_absent=1', '_blank');
  }
  
}
